// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card[data-v-24042aee]{border-radius:2px!important;margin:5px;padding:1.2rem}", ""]);
// Exports
module.exports = exports;
